/**
 * Author: postcodex
 * Date: 2018/08/23
 * Time: 2:01 PM
 */
import {
	APP_PROP_CHANGE,
	SEARCH_ADDRESSES,
	SEARCH_ADDRESSES_SUCCESS,
	SEARCH_ADDRESSES_ERROR,
} from '../actions';

const INITIAL_STATE = {
	searchingAddresses : false,
	addresses          : [],
	searchError        : null,
};

export default function ( state = INITIAL_STATE, action ) {
	switch ( action.type ) {
		case APP_PROP_CHANGE:
			return {
				...state,
				...action.payload,
			};
		case SEARCH_ADDRESSES:
			return {
				...state,
				...action.payload,
				searchingAddresses : true,
			};
		case SEARCH_ADDRESSES_SUCCESS:
			return {
				...state,
				...action.data,
				searchingAddresses : false,
			};
		case SEARCH_ADDRESSES_ERROR:
			return {
				...state,
				searchError : { ...action.error.response.data },
				searchingAddresses : false,
			};
		default:
			return state;
	}
}
